// extracted by mini-css-extract-plugin
export default {"button":"ButtonBack_button__GO1MQ","button--small":"ButtonBack_button--small__-Pj-f","button__icon":"ButtonBack_button__icon__TuD8j"};